import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import FeaturedServices from '../../components/FeaturedServices';
import { TabSection } from '../../components/Tabs';
import WhyChooseUs from '../../components/WhyChooseUs';
import { Helmet } from 'react-helmet';

const AboutSolaric = () => {
  return (
    <div style={{ padding: '4rem 0', background: '#fff' }}>
      <Helmet>
        <title>About | Solaric</title>
      </Helmet>
      <Breadcrumb current='About Solaric' previous='about' />
      <div style={{ marginTop: '2rem' }}>
        <WhyChooseUs title='ABOUT SOLARIC' />
      </div>
      <div style={{ background: '#F7EFEA' }}>
        <FeaturedServices />
      </div>
      <TabSection />
    </div>
  );
};

export default AboutSolaric;
